module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAABV0lEQVR4AeySsUoDQRCG/53NBYuDdDZJbASxS1gkjV2w1xyk8T0sBGOhYCG+gFhIcha+gIX4Bt4Fbe19ALFTs7vOpAskoHKbxjv25272lu9n/h0CP9lwdycfJUd5mgzmKUt7B8/Dfp2PFrIoG+51FOkHKJwy8WSeFNS5JXvH/wpZpJQ2PyE5oMVpjPO09ydlaZLlN8mZeLGp9/LhnYWbfEBRNFck+zoyiqq/lpt8Gji7BY/Dx1Evmd6p52qlVkerfw2zf1u4hCt88akQrZLj3Dx32NzcRvXrFXh7KlzCFb74WOs9xXEE015D7f0eeLkIJuGbdhPiR+uNGFrapRWgEocT87Xz2GjUQFFVW75SmaXw4pGlincE51V4t1kHmi2XU5WmQXMu4y3jLSSBcpAKiXER5D/F69Ryu/XQBK3Gi7IPsu8wJmUuc4Z3AT/g93E4Tfld1bnKvgEAAP//Oa9RjgAAAAZJREFUAwC3pP4VD1TAKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yimou/wjj.png
// module id = uMPg
// module chunks = 1